import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.board.info');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcuser-board-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.board.info/view.scss */
/* src/app/portal.gsdcuser.board.info/view.scss: no such file or directory */`],
})
export class PortalGsdcuserBoardInfoComponent implements OnInit, DoCheck {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() board_id: any;

    public info: any;
    public comments: any = [];
    // public newComment: any = "";

    public prev: any;
    public next: any;

    private lastUrl: string = "";

    public async ngDoCheck() {
        if (this.router.url !== this.lastUrl) {
            this.lastUrl = this.router.url;
            this.board_id = WizRoute.segment.item;
            await this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { board_id: this.board_id });
        if (code != 200) return window.location = "/dashboard";
        this.info = data.info;
        this.info.extra = JSON.parse(this.info.extra.replace(/'/g, '"'));
        // this.comments = data.comments;
        this.comments = data.comments.map(c => ({
            ...c,
            showReplyEditor: false,
            replyContent: '',
            replies: c.replies || []
        }));
        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async delete() {
        let res: any = await this.service.alert.error("정말로 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("delete", { id: this.info.id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.router.navigateByUrl('/board');
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { board_id: this.board_id, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        await this.load();
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }

    public async toggleReplyEditor(comment: any) {
        comment.showReplyEditor = !comment.showReplyEditor;
        await this.service.render();
    }

    public async cancelReply(comment: any) {
        comment.showReplyEditor = false;
        comment.replyContent = '';
        await this.service.render();
    }

    public async submitReply(comment: any) {
        if (!comment.replyContent?.trim()) return await this.service.alert.warning("답글을 작성해주세요.");

        const { code, data } = await wiz.call('replyWrite', { board_id: this.board_id, comment_id: comment.id, content: comment.replyContent });
        if (code !== 200) return await this.service.alert.error("Error!");

        await this.load();
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }
}

export default PortalGsdcuserBoardInfoComponent;